<template>
  <div class="refund-goods">
    <img :src="goods.cover" alt="">
    <div class="info">
      <p class="van-multi-ellipsis--l2">{{ goods.title }}</p>
      <span>{{ goods.size }}</span>
    </div>
    <div class="price">
      <p>¥{{ goods.price }}</p>
      <span>x{{ goods.count }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'refund-goods',
  props: {
    goods: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .refund-goods
    display flex
    padding 30px
    margin-top 20px
    background #fff
    &>img
      width 105px
      height 105px
      border-radius 5px
      margin-right 23px
    .info
      flex 1
      padding-right 78px
      &>p
        line-height 30px
        margin-bottom 23px
        font-size 26px
        color #6F6F6F
      &>span
        font-size 24px
        color #9F9F9F
    .price
      text-align right
      &>p
        margin-bottom 74px
        font-size 24px
        color #000000
      &>span
        font-size 24px
        color #9F9F9F
</style>
